import { Controller } from "@hotwired/stimulus";

// Replaces Bootstrap's Collapse JS — toggles `show` class on `.collapse` elements
export default class extends Controller {
  static targets = ["content"];
  static values = { open: { type: Boolean, default: false } };

  openValueChanged() {
    this.contentTargets.forEach((el) => {
      el.classList.toggle("show", this.openValue);
    });
  }

  toggle() {
    this.openValue = !this.openValue;
  }
}
